/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { gql } from '@apollo/client';
import { object, shape, string } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { compose } from 'recompose';
import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';
import EcardsBlock from './EcardsBlock';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';

const brandSelectors = app.ducks.brand.selectors;
// TODO make the Ecards code dynamic
const EcardsPage = ({ brand, page }) => {
    const { contentType } = page;
    const isGlobal = page.path.includes('ecards');
    const isDelayed = page.path.includes('e-cards');

    const ECARDS_PAGE_QUERY_UNIQUE = gql`
    query EcardsQuery {
        findContentPage(brand: "${brand['domain-name']}",url: "${page.path}", environment: "${GRAPHQL_ENV}", contentType: "${contentType}", locale: "en-us") {
            content
        }
    }`;

    const ECARDS_PAGE_QUERY = gql`
    query EcardsQuery {
        findContent(brand: "global", environment: "${GRAPHQL_ENV}", contentType: "template_page_ecards", locale: "en-us") {
            content
        }
    }`;

    const DELAYED_ECARDS_PAGE_QUERY = gql`
    query EcardsQuery {
        findContent(brand: "global", environment: "${GRAPHQL_ENV}", contentType: "template_page_e_cards", locale: "en-us") {
            content
        }
    }`;

    const pageQueryType = () => {
        if (isGlobal) {
            return ECARDS_PAGE_QUERY;
        }
        if (isDelayed) {
            return DELAYED_ECARDS_PAGE_QUERY;
        }
        return ECARDS_PAGE_QUERY_UNIQUE;
    };

    const domain = brand.domain;
    return (
        <Query query={pageQueryType()}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: ECARDS_PAGE_QUERY,
                        component: 'EcardsPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: ECARDS_PAGE_QUERY,
                        component: 'EcardsPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if ((isGlobal || isDelayed) ? !data?.findContent?.content : !data?.findContentPage?.content) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: ECARDS_PAGE_QUERY,
                        component: 'EcardsPage.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                let EcardsBlocks = null;
                if (data?.findContent?.content !== null || data?.findContentPage?.content !== null) {
                    EcardsBlocks = (isGlobal || isDelayed) ? data.findContent.content.entries[0] : data.findContentPage.content.entries[0];
                }

                return (
                    <>
                        {EcardsBlocks ? <EcardsBlock data={EcardsBlocks} domain={domain} isGlobal={isGlobal} isDelayed={isDelayed} /> : null}
                    </>
                );
            }}
        </Query>
    );
};

EcardsPage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});
const enhance = compose(
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
    connect(mapStateToProps),
);

export default enhance(EcardsPage);
